import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=21627288&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=21627288&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21627288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21627288')) {
      api.createRecord('21627288', component.options)
    } else {
      api.reload('21627288', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=21627288&scoped=true", function () {
      api.rerender('21627288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/localization/nationalManage/addModal.vue"
export default component.exports